export const isImage = (path: string): boolean =>
    /\.(jpeg|jpg|gif|png|webp|bmp|svg)$/i.test(path);

export const isVideo = (path: string): boolean =>
    /\.(mp4|webm|ogg|avi|mov|mkv)$/i.test(path);

export const isPdf = (path: string): boolean =>
    /\.(pdf)$/i.test(path);
